import React, { memo } from 'react';

const ReplaceButton = () => (
  <div className="d-inline-flex flex-no-shrink align-self-center pl-sm">
    <i className="hicon-warning text-16" style={{ color: '#BF9139' }} />
  </div>
);

export default memo(ReplaceButton);
